import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { BasketProvider } from "./basket/BasketContext";
import { Layout } from "./components/Layout";
import { AboutPage } from "./pages/AboutPage";
import { BasketPage } from "./pages/BasketPage";
import { CollectionPage } from "./pages/CollectionPage";
import { CollectionsPage } from "./pages/CollectionsPage";
import { ContactPage } from "./pages/ContactPage";
import { DeliveryPage } from "./pages/DeliveryPage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { ProductPage } from "./pages/ProductPage";
import { TermsPage } from "./pages/TermsPage";

export function App() {
  return (
    <BasketProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/collections" element={<CollectionsPage />} />
            <Route path="/collections/:slug" element={<CollectionPage />} />
            <Route path="/products/:slug" element={<ProductPage />} />
            <Route path="/basket" element={<BasketPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/delivery-and-returns" element={<DeliveryPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/delivery" element={<Navigate to="/delivery-and-returns" replace />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </BasketProvider>
  );
}
